import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "get-start" */ "../views/HomeView.vue"),
  },
  {
    path: "/get-start",
    name: "get-start",
    component: () =>
      import(/* webpackChunkName: "get-start" */ "../views/GetStartView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
